export const categoryRoutes = {
	categoryIndex: '/categories',
	categoryHistory: (id?: string) => `/categories/${id ?? ':id'}/history`
} as const
